export const validateEmail = (email: string) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email || email.length === 0) {
    return "Email is required";
  } else if (!re.test(email)) {
    return "Email is invalid";
  }
  return "";
};

export const validateAlias = (alias: string) => {
  if (!alias || alias.length === 0) {
    return "Alias is required";
  } else if (alias.length < 3) {
    return "Alias must be at least 3 characters";
  } else if (alias.length > 50) {
    return "Alias must be less than 50 characters";
  } else if (!/^[a-zA-Z0-9 ]+$/.test(alias)) {
    return "Alias can only contain letters and numbers";
  }
  return "";
};

export const validateName = (name: string) => {
  if (!name || name.length === 0) {
    return "Name is required";
  } else if (name.length < 2) {
    return "Name must be at least 3 characters";
  }
  return "";
};

export const validateGender = (gender: string) => {
  if (!gender || gender.length === 0) {
    return "Gender is required";
  }
  return "";
};

export const validatePhone = (phone: string) => {
  if (!phone || phone.length === 0) {
    return "";
  } else if (!/^[+]?([0-9]| )+$/.test(phone)) {
    return "Phone number can only contain numbers, spaces and '+'";
  }
  return "";
};

export const validatePassword = (password: string) => {
  if (!password || password.length === 0) {
    return "Password is required";
  } else if (password.length < 6) {
    return "Password must be at least 6 characters";
  } else if (password.length > 20) {
    return "Password must be less than 20 characters";
  }
  return "";
};

export const validateConfirmPassword = (
  password: string,
  confirmPassword: string,
) => {
  if (!confirmPassword || confirmPassword.length === 0) {
    return "Confirm Password is required";
  } else if (password !== confirmPassword) {
    return "Password and Confirm Password do not match";
  }
  return "";
};

export const avatars = [
  {
    src: "/avatars/new-avatar-01.png",
    size: {
      desktop: {
        width: 850,
        height: 950,
      },
      mobile: {
        width: 600,
        height: 600,
      },
    },
    profilePosition: {
      x: 50,
    },
  },
  {
    src: "/avatars/new-avatar-02.png",
    size: {
      desktop: {
        width: 850,
        height: 950,
      },
      mobile: {
        width: 600,
        height: 600,
      },
    },
    profilePosition: {
      x: 50,
    },
  },
  {
    src: "/avatars/new-avatar-03.png",
    size: {
      desktop: {
        width: 850,
        height: 950,
      },
      mobile: {
        width: 600,
        height: 600,
      },
    },
    profilePosition: {
      x: 50,
    },
  },
  {
    src: "/avatars/new-avatar-04.png",
    size: {
      desktop: {
        width: 850,
        height: 950,
      },
      mobile: {
        width: 600,
        height: 600,
      },
    },
    profilePosition: {
      x: 50,
    },
  },
  {
    src: "/avatars/new-avatar-05.png",
    size: {
      desktop: {
        width: 850,
        height: 950,
      },
      mobile: {
        width: 600,
        height: 600,
      },
    },
    profilePosition: {
      x: 50,
    },
  },
  {
    src: "/avatars/new-avatar-06.png",
    size: {
      desktop: {
        width: 850,
        height: 950,
      },
      mobile: {
        width: 600,
        height: 600,
      },
    },
    profilePosition: {
      x: 50,
    },
  },
  {
    src: "/avatars/new-avatar-07.png",
    size: {
      desktop: {
        width: 850,
        height: 950,
      },
      mobile: {
        width: 600,
        height: 600,
      },
    },
    profilePosition: {
      x: 50,
    },
  },
  {
    src: "/avatars/new-avatar-08.png",
    size: {
      desktop: {
        width: 850,
        height: 950,
      },
      mobile: {
        width: 600,
        height: 600,
      },
    },
    profilePosition: {
      x: 50,
    },
  },
];

// Warms the browser cache with the avatar images (~4.5MB total) so the pickers
// on /setup-profile and /profile render instantly instead of downloading on
// arrival. Fire-and-forget: failures resolve silently.
export const preloadAvatars = () =>
  Promise.all(
    avatars.map(
      (avatar) =>
        new Promise<void>((resolve) => {
          const img = new Image();
          img.onload = () => resolve();
          img.onerror = () => resolve();
          img.src = avatar.src;
        }),
    ),
  );

export const formatId = (id: number, length = 6) => {
  return id.toString().padStart(length, "0");
};
